import { Route, useRouteMatch } from 'react-router-dom';

// Pages.
import ProjectPlanPage from 'pages/galleria/master-plane/zone-7/Type-B/plan/ProjectPlanPage';
import ProjectGalleryPage from 'pages/galleria/master-plane/zone-7/Type-B/gallery/ProjectGalleryPage';
import PaymentPage from 'pages/galleria/master-plane/zone-7/Type-B/payment/PaymentPage';
const Index = () => {
  const { path } = useRouteMatch();
  return (
    <>
      <Route exact path={`/galleria/master-plan/zone-7/type-b/plan`}>
        <ProjectPlanPage />
      </Route>
      <Route exact path={`/galleria/master-plan/zone-7/type-b/gallery`}>
        <ProjectGalleryPage />
      </Route>
      <Route exact path={`/galleria/master-plan/zone-7/type-b/payment`}>
        <PaymentPage />
      </Route>
    </>
  );
};

export default Index;
